import gql from 'graphql-tag';

export const schema = gql`
input socialMediaInput {
  instagram: String!,
  facebook: String,
  spotify: String,
  youtube: String,
  twitter: String,
  website: String,
}

input countryCityInput {
  value: String,
  label: String,
}

input messageRejectInput {
  preDefined: String,
  custom: String
}

input SubcategoryInput {
    _id: String!,
    name: String!,
  }

input CategoryInput {
    _id: String!,
    name: String!,
    subCategory: [SubcategoryInput],
  }

type defaultMessageSchema {
  message: String
}

input categoriesInput {
  _id: String,
  name: String,
  categoryId: String,
}

input audienceAgeOfferInput {
  age_13_17: Boolean,
  age_18_20: Boolean,
  age_21_24: Boolean,
  age_25_29: Boolean,
  age_30_34: Boolean,
  age_35_44: Boolean,
  age_45_64: Boolean,
  age_65_plus: Boolean
}

input targetAudienceInput {
  audienceAge: audienceAgeOfferInput
  country: [countryCityInput]!
  gender: [String]
}

input shareTypeInput {
  instagram: Boolean,
  facebook: Boolean,
  twitter: Boolean,
  spotify: Boolean,
  youtube: Boolean,
}

input campaignTimelineInput {
  startDate: Date,
  endDate: Date,
  shareTypeInput: shareTypeInput
  description: String,
  hashTag: String,
  campaignTitle: String,
}

input inviteArtistListInput {
  artistId: String,
  basePrice: Float,
  name: String,
  email: String
}

input importUsersSchema  {
  primaryContactName: String,
  country: countryCityInput!,
  bio: String!,
  city: countryCityInput,
  state: countryCityInput,
  email: String!,
  contactNumber: String!
  genre: [String]!,
  companyName: String,
  name: String,
  artistImage: String!,
  managerImage: String,
  managerFirstName: String,
  managerLastName: String
  socialMedia: socialMediaInput,
  shippingAddress: String,
  isErrorRegion: Boolean
}



type unseenMessageInput {
  _id: String,
  conversationId: String,
  offerId: Float,
  otherUserId: String,
  unseenMessageCount: Int,
  timestamp: Int}
`;

/** Client mutation */

export const UNSEEN_MESSAGES_MUTATION = gql`
mutation unseenMessages($unseenMessages: [unseenMessageInput]) {
  unseenMessages(unseenMessages: $unseenMessages) @client
}`;

export const ACTIVE_ARTIST_MUTATION = gql`
mutation activeArtist($artistImage: String! , $name: String!, $_id: String!, $isDefault: Boolean, $email: String) {
  activeArtist(artistImage: $artistImage, name: $name, _id: $_id, isDefault: $isDefault, email: $email) @client
}`;

export const UPDATE_NOTIFICATION = gql`
  mutation setNotification($notification: Boolean , $emailNotification: Boolean) {
    setNotification(notification: $notification, emailNotification: $emailNotification) @client
}`;

/** end client mutation */
export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      message,
      data {
        email,
        role,
        token,
        isFirstTime,
        _id,
        managerLastName,
        managerFirstName,
        name,
        isQuestionnaireSkipped,
        inviteOfferId
      }
    }
}`;

export const MANAGER_REGISTER_MUTATION = gql`
  mutation signUp($role: String, $primaryContactName: String, $country: countryCityInput!, $bio: String!, $city: countryCityInput, $state: countryCityInput,
     , $email: String!, $contactNumber: String!, $genre: [String]!, , $companyName: String, $name: String,
       $artistImage: String!, $managerImage: String,  $managerFirstName: String, $managerLastName: String
     $socialMedia: socialMediaInput, $token: String, $shippingAddress: String ) {
      signUp(role: $role, primaryContactName: $primaryContactName, country: $country, bio: $bio,city: $city, state: $state,
        managerFirstName: $managerFirstName, managerLastName: $managerLastName,
        contactNumber: $contactNumber,
        email: $email, genre: $genre, , companyName: $companyName, name: $name, artistImage: $artistImage, managerImage: $managerImage,
        socialMedia: $socialMedia, token: $token, shippingAddress: $shippingAddress) {
          message
          data {
            email,
            role,
            token,
            isFirstTime,
            _id,
            managerLastName,
            managerFirstName,
            name,
           }
        }
}`;
export const CHANGE_PASSWORD = gql` mutation changePassword($oldPassword: String!, $confirmPassword: String!) {
   changePassword(oldPassword: $oldPassword, confirmPassword: $confirmPassword) {
       message
     }
}`;

export const CREATE_PASSWORD = gql` mutation createPassword($password: String!, $token: String) {
  createPassword(password: $password, token: $token) {
      message
    }
}`;

export const FORGOT_PASSWORD = gql` mutation forgetPassword($email: String!) {
  forgetPassword(email: $email) {
      message
    }
}`;

export const LOGOUT_USER = gql` mutation logout {
  logout{
      message
    }
}`;

export const UPDATE_USER = gql`
mutation updateUser($userId: String, $name: String, $primaryContactName: String, $country: countryCityInput, $bio: String,
  , $contactNumber: String, $genre: [String],  $city: countryCityInput, $state: countryCityInput, $companyName: String,
    $artistImage: String, $managerImage: String, $managerFirstName: String, $managerLastName: String, $note: String,
  $socialMedia: socialMediaInput, $isQuestionnaireSkipped: Boolean, $shippingAddress: String) {
    updateUser(userId: $userId, name: $name, primaryContactName: $primaryContactName, country: $country, bio: $bio,
      contactNumber: $contactNumber, genre: $genre, city: $city, state: $state, companyName: $companyName,
      artistImage: $artistImage, managerImage: $managerImage, managerFirstName: $managerFirstName, managerLastName: $managerLastName,
      note: $note, socialMedia: $socialMedia, isQuestionnaireSkipped:$isQuestionnaireSkipped, shippingAddress: $shippingAddress ) {
       message,
        data {
        name,
        managerFirstName,
        managerLastName,
        country {
          label,
          value
        },
        city {
          label,
          value
        },
        state {
          label,
          value
        },
        contactNumber,
        primaryContactName,
        genre,
        bio,
        artistImage,
        managerImage,
        companyName,
        socialMedia {
          instagram,
          facebook,
          twitter,
          website,
          spotify,
          youtube,
        },
        note,
        isQuestionnaireSkipped,
        shippingAddress,
      }
     }
}`;

export const UPDATE_STATUS = gql` mutation updateStatus($userId:String!, $status: String!,
  $rejectReason: messageRejectInput) {
updateStatus(userId: $userId, status: $status, rejectReason: $rejectReason) {
    message
  }
}`;

export const CREATE_USERS = gql` mutation importUsers($users:[importUsersSchema], $columnOrder: String!, $role: String!) {
      importUsers(users: $users, columnOrder: $columnOrder, role: $role) {
      message
    }
}`;

export const DELETE_USER = gql` mutation deleteUser($userId:String!) {
  deleteUser(userId: $userId) {
    message
  }
}`;

export const REMOVE_MANAGER = gql` mutation remove($userId:String) {
  remove(userId: $userId) {
    message
  }
}`;

export const CREATE_OFFER = gql`
  mutation createOffer($title: String, $clientName: String, $campaignType: String, $viewType: String,
    $basePrice: Float, $description: String, $offerUrl: String, $clientLogo: String, , $categories: [categoriesInput],
    $targetAudience: targetAudienceInput, $campaignTimeline: [campaignTimelineInput], $createContract: String,
    $offerMaxDate: Date, $offerMinDate: Date, $inviteArtistList: [inviteArtistListInput], $additionalEmail: [String], $isPublish: Boolean,
    $basePriceText:String, $coverImage: String, $endDeadline: Date, $gigType: String, $isPinToTop: Boolean, $isClientLogoHide: Boolean, $isBetaPostApproval: Boolean
    $isArtistParticipation: Boolean, $isEmailSendToArtist: Boolean) {
      createOffer(title: $title, clientName: $clientName, campaignType: $campaignType, viewType: $viewType,
        basePrice: $basePrice, description: $description, offerUrl: $offerUrl, clientLogo: $clientLogo, categories: $categories,
        targetAudience: $targetAudience, campaignTimeline: $campaignTimeline, createContract: $createContract,
        offerMaxDate: $offerMaxDate, offerMinDate: $offerMinDate, inviteArtistList: $inviteArtistList, additionalEmail: $additionalEmail
        isPublish: $isPublish,basePriceText: $basePriceText, coverImage: $coverImage, endDeadline:$endDeadline, gigType: $gigType, isPinToTop: $isPinToTop,
        isClientLogoHide: $isClientLogoHide, isBetaPostApproval: $isBetaPostApproval, isArtistParticipation: $isArtistParticipation, isEmailSendToArtist: $isEmailSendToArtist) {
          message
        }
}`;

export const EDIT_OFFER = gql`
  mutation editOffer($offerId: String, $title: String, $offerUrl: String, $clientName: String, $campaignType: String, $viewType: String,
    $basePrice: Float, $description: String, $clientLogo: String, , $categories: [categoriesInput],
    $targetAudience: targetAudienceInput, $campaignTimeline: [campaignTimelineInput], $createContract: String,
    $offerMaxDate: Date, $offerMinDate: Date, $inviteArtistList: [inviteArtistListInput],
     $additionalEmail: [String], $isPublish: Boolean, $basePriceText:String, $coverImage: String,
      $endDeadline: Date, $gigType: String, $isPinToTop: Boolean, $isClientLogoHide: Boolean, $isBetaPostApproval: Boolean
      $isArtistParticipation: Boolean, $isEmailSendToArtist: Boolean) {
      editOffer(offerId: $offerId, title: $title, offerUrl: $offerUrl,clientName: $clientName, campaignType: $campaignType, viewType: $viewType,
        basePrice: $basePrice, description: $description, clientLogo: $clientLogo, categories: $categories,
        targetAudience: $targetAudience, campaignTimeline: $campaignTimeline, createContract: $createContract,
        offerMaxDate: $offerMaxDate, offerMinDate: $offerMinDate, inviteArtistList: $inviteArtistList, additionalEmail: $additionalEmail,
        isPublish: $isPublish, basePriceText: $basePriceText, coverImage: $coverImage, endDeadline:$endDeadline, gigType: $gigType, isPinToTop: $isPinToTop,
        isClientLogoHide: $isClientLogoHide, isBetaPostApproval: $isBetaPostApproval, isArtistParticipation: $isArtistParticipation, isEmailSendToArtist: $isEmailSendToArtist ) {
          message
        }
}`;

export const UPDATE_INTREST = gql`
mutation updateIntrests($artistId: String, $category: [CategoryInput]) {
  updateIntrests(artistId: $artistId, category: $category) {
      message
    }
}`;

export const NOTIFICATIONS = gql`
mutation updateSettings($notification: Boolean!, $emailNotification: Boolean!) {
  updateSettings(notification: $notification, emailNotification: $emailNotification) {
    message
  }
}`;

export const UPDATE_FCM_TOKEN = gql`
mutation updateFCMToken($token: String!) {
  updateFCMToken(token: $token) {
    message
  }
}`;

export const SEND_OFFER_CHAT_MOTIFICATION = gql`
mutation sendOfferChatNotification($offerId: ID!, $receiverId: ID!) {
  sendOfferChatNotification(offerId: $offerId, receiverId: $receiverId) {
    message
  }
}`;

export const PLATFORM_INVITE = gql`
mutation platformInvite($emails: [String]!) {
  platformInvite(emails: $emails) {
    message
  }
}`;
